import { render, staticRenderFns } from "./omistaja.vue?vue&type=template&id=923ce1e8&scoped=true&"
import script from "./omistaja.vue?vue&type=script&lang=js&"
export * from "./omistaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923ce1e8",
  null
  
)

export default component.exports